import {
  FeatureFlagsContext,
  SiteUrlsContext,
  WarningStatusChip,
  WarningStatusProps
} from '@tableau/data-catalog-shared';
import { SiteUrls } from '@tableau/shared-urls';
import * as React from 'react';
import { Query } from 'react-apollo';

import {
  TableLineageUpstreamDataQualityWarningsQuery,
  TableLineageUpstreamDataQualityWarningsQueryVariables
} from '../../../gen-src/queries/TableLineageUpstreamDataQualityWarningsQuery';
import { TableLineageUpstreamDataQualityWarningsQueryGql } from '../../queries/TableLineageUpstreamDataQualityWarningsQueryGql';
import { renderQueryResult } from '../renderQueryResult';
import { emptyWarnings, filterOutWarningsFromAnchorUntilCycleIsFixed } from './DataQualityWarningCycleTemporaryFix';

interface LineageWarningTableProps {
  readonly nodeId: string;
}

export function QueryTableOwnAndUpstreamDataQualityWarnings(props: LineageWarningTableProps): JSX.Element {
  const urls = React.useContext(SiteUrlsContext);
  const { publishedConnectionsLineageEnabled } = React.useContext(FeatureFlagsContext);
  const renderData = React.useMemo(() => renderWarnings(urls), [urls]);

  return (
    <Query<TableLineageUpstreamDataQualityWarningsQuery, TableLineageUpstreamDataQualityWarningsQueryVariables>
      query={TableLineageUpstreamDataQualityWarningsQueryGql}
      variables={{ tableId: props.nodeId, first: 10, offset: 0, publishedConnectionsLineageEnabled }}
    >
      {result => renderQueryResult(result, { renderData })}
    </Query>
  );
}

function renderWarnings(urls: SiteUrls
): (data: TableLineageUpstreamDataQualityWarningsQuery) => JSX.Element | null {
  return (data: TableLineageUpstreamDataQualityWarningsQuery): JSX.Element | null => {
    const table = data.databaseTables && data.databaseTables[0] ? data.databaseTables[0] : null;
    if (!table) {
      return null;
    }

    const props: WarningStatusProps = {
      subjectArea: 'DatabaseTable',
      kind: 'graph',
      anchoredAsset: { __typename: 'DataQualityWarning', asset: { ...table } },
      anchoredWarnings: table.dataQualityWarnings,
      iconOnly: false,
      urls,
      upstreamWarnings: filterOutWarningsFromAnchorUntilCycleIsFixed(table.id, table.upstreamDataQualityWarningsConnection?.nodes || emptyWarnings)
    }

    return <WarningStatusChip {...props} />
  }
}
